import { v4 } from "uuid";

import { getItemFromSessionStorage, setItemInSessionStorage } from "../../hooks/sessionStorage";

const CHAT_ID_KEY = "_zenvoya_chat_id";

export function getChatId(): string {
  return getItemFromSessionStorage(CHAT_ID_KEY) || "";
}

export function setChatId(chatId: string): void {
  setItemInSessionStorage(CHAT_ID_KEY, chatId);
}

export function ensureChatId(): string {
  const existing = getItemFromSessionStorage(CHAT_ID_KEY);
  if (existing) return existing;
  const fresh = v4();
  setItemInSessionStorage(CHAT_ID_KEY, fresh);
  return fresh;
}
